import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
  captureExamEvent,
  EXAM_EVENTS,
  RETAKE_PHASE,
} from 'src/services/posthogEvents';

import { I18NextNS } from 'src/models/Language.model';
import { EyesPosition } from 'src/models/Session.model';

interface RetakeButtonProps {
  gradableEyesPosition: EyesPosition | undefined;
  handleRetake: (position: EyesPosition) => void;
  handleCloseAnalyzingProgressModal: () => void;
}

export default function RetakeButton({
  gradableEyesPosition,
  handleRetake,
  handleCloseAnalyzingProgressModal,
}: RetakeButtonProps) {
  const { t } = useTranslation(I18NextNS.PAGES, { keyPrefix: 'newExam' });

  const postAnalysisRetakeProps = (target: EyesPosition) => ({
    target,
    phase: RETAKE_PHASE.POST_ANALYSIS,
  });

  const handleRetakeBothEyes = () => {
    captureExamEvent(
      EXAM_EVENTS.RETAKE_REQUESTED,
      postAnalysisRetakeProps(EyesPosition.BOTH),
    );
    handleRetake(EyesPosition.BOTH);
    handleCloseAnalyzingProgressModal();
  };

  const handleRetakeLeftEye = () => {
    captureExamEvent(
      EXAM_EVENTS.RETAKE_REQUESTED,
      postAnalysisRetakeProps(EyesPosition.LEFT),
    );
    handleRetake(EyesPosition.LEFT);
    handleCloseAnalyzingProgressModal();
  };

  const handleRetakeRightEye = () => {
    captureExamEvent(
      EXAM_EVENTS.RETAKE_REQUESTED,
      postAnalysisRetakeProps(EyesPosition.RIGHT),
    );
    handleRetake(EyesPosition.RIGHT);
    handleCloseAnalyzingProgressModal();
  };

  if (gradableEyesPosition === undefined) {
    return (
      <Button
        variant="primary"
        onClick={handleRetakeBothEyes}
        data-track="exam.retake-modal.retake-both-eyes"
        data-test="analyzing-modal-retake-both-eyes"
        data-observe
      >
        {t('retake')}
      </Button>
    );
  }

  if (gradableEyesPosition === EyesPosition.LEFT) {
    return (
      <Button
        variant="primary"
        onClick={handleRetakeRightEye}
        data-track="exam.retake-modal.retake-right-eye"
        data-test="analyzing-modal-retake-right-eye"
        data-observe
      >
        {t('retakeRightEye')}
      </Button>
    );
  }

  if (gradableEyesPosition === EyesPosition.RIGHT) {
    return (
      <Button
        variant="primary"
        onClick={handleRetakeLeftEye}
        data-track="exam.retake-modal.retake-left-eye"
        data-test="analyzing-modal-retake-left-eye"
        data-observe
      >
        {t('retakeLeftEye')}
      </Button>
    );
  }
}
